import React from 'react';
import { Sparklines, SparklinesLine } from 'react-sparklines';

const getColor = (score) => {
  if (score == null) return '#444';
  if (score >= 80) return '#8fd6b1';
  if (score >= 60) return '#1f7a4d';
  if (score >= 40) return '#e6be63';
  if (score >= 20) return '#d9842b';
  return '#aa3d33';
};

const AssetHeatmap = ({ assets, onSelect, selectedSymbol }) => {
  const rows = [];
  for (let i = 0; i < 40; i += 10) {
    rows.push(assets.slice(i, i + 10));
  }

  const isEmpty = !assets || assets.length === 0;

  return (
    <div className="asset-heatmap">
      <div className="asset-heatmap__header">
        <div>
          <strong>Heatmap des actifs</strong>
          <span>Score composite des 40 premiers actifs du flux courant.</span>
        </div>
      </div>
      {isEmpty ? (
        <div className="asset-heatmap__empty">
          Aucun actif à afficher dans la heatmap.
        </div>
      ) : (
        <div className="asset-heatmap__grid">
            {rows.map((row, idx) => (
              <div key={"row-" + idx} className="asset-heatmap__row">
                {row.map(asset => (
                  <button
                    type="button"
                    key={asset.symbol || asset.name || idx}
                    className={`asset-heatmap__cell${selectedSymbol && (asset.symbol || asset.code) === selectedSymbol ? ' asset-heatmap__cell--selected' : ''}`}
                    title={asset.symbol + ' : ' + (asset.compositeScore ?? '—')}
                    style={{ background: getColor(asset.compositeScore) }}
                    onClick={() => onSelect?.(asset)}
                  >
                  <div>{asset.symbol}</div>
                  <div className="asset-heatmap__score">{asset.compositeScore ?? '—'}</div>
                  {asset.sparkline ? (
                    <div className="asset-heatmap__sparkline">
                      <Sparklines data={asset.sparkline} width={40} height={16} margin={2}>
                        <SparklinesLine color="#fff" style={{strokeWidth: 2, fill: 'none'}} />
                      </Sparklines>
                    </div>
                  ) : null}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AssetHeatmap;
